const PUBLIC_ROUTES = [
  '/login',
  '/invitation',
  '/signup',
  '/beta',
  '/email-verified',
  '/override',
];

export const isPublicRoute = (pathname: string) =>
  PUBLIC_ROUTES.some(route => pathname.startsWith(route));

type AppLocation = {
  pathname: string;
  search: string;
};

export const getOrganizationInvitationRoute = ({
  pathname,
  search,
}: AppLocation): string | undefined => {
  if (pathname !== '/') {
    return undefined;
  }

  const searchParams = new URLSearchParams(search);
  if (!searchParams.get('invitation') || !searchParams.get('organization')) {
    return undefined;
  }

  return `/invitation?${searchParams.toString()}`;
};
